/* eslint-disable max-lines */

import { Route } from '@angular/router';

import { provideTemplateDefinition } from './app/providers/template-definition.provider';
import {
  AccountRecoveryRequestStartedTemplateComponent,
  AccountRecoveryRequestStartedTemplateMocks,
} from './app/templates/account-recovery-request-started/account-recovery-request-started.component';
import {
  AccountRecoveryRequestUrlTemplateComponent,
  AccountRecoveryRequestUrlTemplateMocks,
} from './app/templates/account-recovery-request-url/account-recovery-request-url.component';
import {
  AdminDeletedTemplateComponent,
  AdminDeletedTemplateMocks,
} from './app/templates/admin-deleted/admin-deleted.component';
import {
  AdminDeletionRequestCreatedTemplateComponent,
  AdminDeletionRequestCreatedTemplateMocks,
} from './app/templates/admin-deletion-request-created/admin-deletion-request-created.component';
import {
  AdminDeletionScheduledTemplateComponent,
  AdminDeletionScheduledTemplateMocks,
} from './app/templates/admin-deletion-scheduled/admin-deletion-scheduled.component';
import {
  BrokenSyncAlertTemplateComponent,
  BrokenSyncAlertTemplateMocks,
} from './app/templates/broken-sync-alert/broken-sync-alert.component';
import {
  CompanyDeletedTemplateComponent,
  CompanyDeletedTemplateMocks,
} from './app/templates/company-deleted/company-deleted.component';
import {
  CompanyDeletionRequestCreatedTemplateComponent,
  CompanyDeletionRequestCreatedTemplateMocks,
} from './app/templates/company-deletion-request-created/company-deletion-request-created.component';
import { CompanyDeletionScheduledTemplateMocks } from './app/templates/company-deletion-scheduled/company-deletion-scheduled.component';
import {
  CompleteAccountSetupTemplateComponent,
  CompleteAccountSetupTemplateMocks,
} from './app/templates/complete-account-setup/complete-account-setup.component';
import { DemoTemplateComponent, DemoTemplateMocks } from './app/templates/demo/demo.component';
import {
  EeoDataRequestTemplateComponent,
  EeoDataRequestTemplateMocks,
} from './app/templates/eeo-data-request/eeo-data-request.component';
import {
  EmailChangeStartProcessTemplateComponent,
  EmailChangeStartProcessTemplateMocks,
} from './app/templates/email-change-start-process/email-change-start-process.component';
import {
  EmailChangeVerificationTemplateComponent,
  EmailChangeVerificationTemplateMocks,
} from './app/templates/email-change-verification/email-change-verification.component';
import {
  EventNotificationTemplateComponent,
  EventNotificationTemplateMocks,
} from './app/templates/event-notification/event-notification.component';
import {
  GdprAutoConsentTemplateComponent,
  GdprAutoConsentTemplateMocks,
} from './app/templates/gdpr-auto-consent/gdpr-auto-consent.component';
import {
  GdprReportTemplateComponent,
  GdprReportTemplateMocks,
} from './app/templates/gdpr-report/gdpr-report.component';
import {
  InactiveAdminDeletedTemplateComponent,
  InactiveAdminDeletedTemplateMocks,
} from './app/templates/inactive-admin-deleted/inactive-admin-deleted.component';
import { InactiveCompanyDeletedTemplateMocks } from './app/templates/inactive-company-deleted/inactive-company-deleted.component';
import {
  JoinCompanyTemplateComponent,
  JoinCompanyTemplateMocks,
} from './app/templates/join-company/join-company.component';
import {
  MultipleNotificationsTemplateComponent,
  MultipleNotificationsTemplateMocks,
} from './app/templates/multiple-notifications/multiple-notifications.component';
import {
  NewCandidateTemplateComponent,
  NewCandidateTemplateMocks,
} from './app/templates/new-candidate/new-candidate.component';
import {
  NewCandidatesReportTemplateComponent,
  NewCandidatesReportTemplateMocks,
} from './app/templates/new-candidates-report/new-candidates-report.component';
import {
  NotificationMentionTemplateComponent,
  NotificationMentionTemplateMocks,
} from './app/templates/notification-mention/notification-mention.component';
import {
  OrderInvoiceTemplateComponent,
  OrderInvoiceTemplateMocks,
} from './app/templates/order-invoice/order-invoice.component';
import {
  PaymentFailedTemplateComponent,
  PaymentFailedTemplateMocks,
} from './app/templates/payment-failed/payment-failed.component';
import {
  ReferralApplicationConfirmationTemplateComponent,
  ReferralApplicationConfirmationTemplateMocks,
} from './app/templates/referral-application-confirmation/referral-application-confirmation.component';
import {
  ReferralEmailConfirmationTemplateComponent,
  ReferralEmailConfirmationTemplateMocks,
} from './app/templates/referral-email-confirmation/referral-email-confirmation.component';
import {
  ReferralSendInvitationTemplateComponent,
  ReferralSendInvitationTemplateMocks,
} from './app/templates/referral-send-invitation/referral-send-invitation.component';
import {
  RequisitionsApprovalRequestTemplateComponent,
  RequisitionsApprovalRequestTemplateMocks,
} from './app/templates/requisitions-approval-request/requisitions-approval-request.component';
import {
  ResetPasswordTemplateComponent,
  ResetPasswordTemplateMocks,
} from './app/templates/reset-password/reset-password.component';
import {
  ShareContainerTemplateComponent,
  ShareContainerTemplateMocks,
} from './app/templates/share-container/share-container.component';
import {
  SignUpVerificationReminderTemplateComponent,
  SignUpVerificationReminderTemplateMocks,
} from './app/templates/sign-up-verification-reminder/sign-up-verification-reminder.component';
import {
  SingleNotificationTemplateComponent,
  SingleNotificationTemplateMocks,
} from './app/templates/single-notification/single-notification.component';
import {
  SlotsUpgradedTemplateComponent,
  SlotsUpgradedTemplateMocks,
} from './app/templates/slots-upgraded/slots-upgraded.component';
import {
  SsoEnabledTemplateComponent,
  SsoEnabledTemplateMocks,
} from './app/templates/sso-enabled/sso-enabled.component';
import {
  TextingNotificationTemplateComponent,
  TextingNotificationTemplateMocks,
} from './app/templates/texting-notification/texting-notification.component';
import {
  TextingNumberDeletionScheduledTemplateComponent,
  TextingNumberDeletionScheduledTemplateMocks,
} from './app/templates/texting-number-deletion-scheduled/texting-number-deletion-scheduled.component';
import {
  VerificationCodeTemplateComponent,
  VerificationCodeTemplateMocks,
} from './app/templates/verification-code/verification-code.component';
import {
  VerificationUrlAndCodeTemplateComponent,
  VerificationUrlAndCodeTemplateMocks,
} from './app/templates/verification-url-and-code/verification-url-and-code.component';
import {
  VerificationUrlTemplateComponent,
  VerificationUrlTemplateMocks,
} from './app/templates/verification-url/verification-url.component';
import {
  WebhookDeliveryFailedTemplateComponent,
  WebhookDeliveryFailedTemplateMocks,
} from './app/templates/webhook-delivery-failed/webhook-delivery-failed.component';
import {
  WebhookPlanDowngradedTemplateComponent,
  WebhookPlanDowngradedTemplateMocks,
} from './app/templates/webhook-plan-downgraded/webhook-plan-downgraded.component';

export const TEMPLATE_ROUTES: Array<Route & { name: string; render: boolean }> = [
  ...provideTemplateDefinition('demo', DemoTemplateComponent, DemoTemplateMocks),
  ...provideTemplateDefinition(
    'account-recovery-request-started',
    AccountRecoveryRequestStartedTemplateComponent,
    AccountRecoveryRequestStartedTemplateMocks,
  ),
  ...provideTemplateDefinition(
    'account-recovery-request-url',
    AccountRecoveryRequestUrlTemplateComponent,
    AccountRecoveryRequestUrlTemplateMocks,
  ),
  ...provideTemplateDefinition(
    'admin-deleted',
    AdminDeletedTemplateComponent,
    AdminDeletedTemplateMocks,
  ),
  ...provideTemplateDefinition(
    'admin-deletion-request-created',
    AdminDeletionRequestCreatedTemplateComponent,
    AdminDeletionRequestCreatedTemplateMocks,
  ),
  ...provideTemplateDefinition(
    'admin-deletion-scheduled',
    AdminDeletionScheduledTemplateComponent,
    AdminDeletionScheduledTemplateMocks,
  ),
  ...provideTemplateDefinition(
    'broken-sync-alert',
    BrokenSyncAlertTemplateComponent,
    BrokenSyncAlertTemplateMocks,
  ),
  ...provideTemplateDefinition(
    'company-deleted',
    CompanyDeletedTemplateComponent,
    CompanyDeletedTemplateMocks,
  ),
  ...provideTemplateDefinition(
    'company-deletion-request-created',
    CompanyDeletionRequestCreatedTemplateComponent,
    CompanyDeletionRequestCreatedTemplateMocks,
  ),
  ...provideTemplateDefinition(
    'company-deletion-scheduled',
    AdminDeletionScheduledTemplateComponent,
    CompanyDeletionScheduledTemplateMocks,
  ),
  ...provideTemplateDefinition(
    'complete-account-setup',
    CompleteAccountSetupTemplateComponent,
    CompleteAccountSetupTemplateMocks,
  ),
  ...provideTemplateDefinition(
    'eeo-data-request',
    EeoDataRequestTemplateComponent,
    EeoDataRequestTemplateMocks,
  ),
  ...provideTemplateDefinition(
    'email-change-start-process',
    EmailChangeStartProcessTemplateComponent,
    EmailChangeStartProcessTemplateMocks,
  ),
  ...provideTemplateDefinition(
    'email-change-verification',
    EmailChangeVerificationTemplateComponent,
    EmailChangeVerificationTemplateMocks,
  ),
  ...provideTemplateDefinition(
    'event-notification',
    EventNotificationTemplateComponent,
    EventNotificationTemplateMocks,
  ),
  ...provideTemplateDefinition(
    'gdpr-auto-consent',
    GdprAutoConsentTemplateComponent,
    GdprAutoConsentTemplateMocks,
  ),
  ...provideTemplateDefinition('gdpr-report', GdprReportTemplateComponent, GdprReportTemplateMocks),
  ...provideTemplateDefinition(
    'inactive-admin-deleted',
    InactiveAdminDeletedTemplateComponent,
    InactiveAdminDeletedTemplateMocks,
  ),
  ...provideTemplateDefinition(
    'inactive-company-deleted',
    InactiveAdminDeletedTemplateComponent,
    InactiveCompanyDeletedTemplateMocks,
  ),
  ...provideTemplateDefinition(
    'join-company',
    JoinCompanyTemplateComponent,
    JoinCompanyTemplateMocks,
  ),
  ...provideTemplateDefinition(
    'multiple-notifications',
    MultipleNotificationsTemplateComponent,
    MultipleNotificationsTemplateMocks,
  ),
  ...provideTemplateDefinition(
    'new-candidate',
    NewCandidateTemplateComponent,
    NewCandidateTemplateMocks,
  ),
  ...provideTemplateDefinition(
    'new-candidates-report',
    NewCandidatesReportTemplateComponent,
    NewCandidatesReportTemplateMocks,
  ),
  ...provideTemplateDefinition(
    'notification-mention',
    NotificationMentionTemplateComponent,
    NotificationMentionTemplateMocks,
  ),
  ...provideTemplateDefinition(
    'order-invoice',
    OrderInvoiceTemplateComponent,
    OrderInvoiceTemplateMocks,
  ),
  ...provideTemplateDefinition(
    'payment-failed',
    PaymentFailedTemplateComponent,
    PaymentFailedTemplateMocks,
  ),
  ...provideTemplateDefinition(
    'referral-application-confirmation',
    ReferralApplicationConfirmationTemplateComponent,
    ReferralApplicationConfirmationTemplateMocks,
  ),
  ...provideTemplateDefinition(
    'referral-email-confirmation',
    ReferralEmailConfirmationTemplateComponent,
    ReferralEmailConfirmationTemplateMocks,
  ),
  ...provideTemplateDefinition(
    'referral-send-invitation',
    ReferralSendInvitationTemplateComponent,
    ReferralSendInvitationTemplateMocks,
  ),
  ...provideTemplateDefinition(
    'requisitions-approval-request',
    RequisitionsApprovalRequestTemplateComponent,
    RequisitionsApprovalRequestTemplateMocks,
  ),
  ...provideTemplateDefinition(
    'reset-password',
    ResetPasswordTemplateComponent,
    ResetPasswordTemplateMocks,
  ),
  ...provideTemplateDefinition(
    'share-container',
    ShareContainerTemplateComponent,
    ShareContainerTemplateMocks,
  ),
  ...provideTemplateDefinition(
    'sign-up-verification-reminder',
    SignUpVerificationReminderTemplateComponent,
    SignUpVerificationReminderTemplateMocks,
  ),
  ...provideTemplateDefinition(
    'single-notification',
    SingleNotificationTemplateComponent,
    SingleNotificationTemplateMocks,
  ),
  ...provideTemplateDefinition(
    'slots-upgraded',
    SlotsUpgradedTemplateComponent,
    SlotsUpgradedTemplateMocks,
  ),
  ...provideTemplateDefinition('sso-enabled', SsoEnabledTemplateComponent, SsoEnabledTemplateMocks),
  ...provideTemplateDefinition(
    'verification-code',
    VerificationCodeTemplateComponent,
    VerificationCodeTemplateMocks,
  ),
  ...provideTemplateDefinition(
    'verification-url',
    VerificationUrlTemplateComponent,
    VerificationUrlTemplateMocks,
  ),
  ...provideTemplateDefinition(
    'verification-url-and-code',
    VerificationUrlAndCodeTemplateComponent,
    VerificationUrlAndCodeTemplateMocks,
  ),
  ...provideTemplateDefinition(
    'webhook-delivery-failed',
    WebhookDeliveryFailedTemplateComponent,
    WebhookDeliveryFailedTemplateMocks,
  ),
  ...provideTemplateDefinition(
    'webhook-plan-downgraded',
    WebhookPlanDowngradedTemplateComponent,
    WebhookPlanDowngradedTemplateMocks,
  ),
  ...provideTemplateDefinition(
    'texting-notification',
    TextingNotificationTemplateComponent,
    TextingNotificationTemplateMocks,
  ),
  ...provideTemplateDefinition(
    'texting-number-deletion-scheduled',
    TextingNumberDeletionScheduledTemplateComponent,
    TextingNumberDeletionScheduledTemplateMocks,
  ),
];
